import React from 'react';
import { Helmet } from 'react-helmet-async';
import IntroductionTabs from '../../IntroductionTabs';
import BusinessTransportProcessSection from './BusinessTransportProcessSection';
import './businessfield.css';

const BusinessProcessPage = () => {
  const canonical = 'https://www.xn--o39ap7bo6pk0bo2x.com/business/process';
  const title = '운송 프로세스 - 가까운물류';
  const desc = '가까운물류의 운송 프로세스를 확인하세요.';

  return (
    <div className="business-page">
      <Helmet>
        <title>{title}</title>
        <link rel="canonical" href={canonical} />
        <meta name="description" content={desc} />
        <meta property="og:type" content="website" />
        <meta property="og:title" content={title} />
        <meta property="og:description" content={desc} />
        <meta property="og:url" content={canonical} />
        <meta property="og:site_name" content="주식회사 가까운물류" />
        <meta property="og:image" content="https://www.xn--o39ap7bo6pk0bo2x.com/og-1200x630.png?v=1" />
      </Helmet>

      <IntroductionTabs type="business">
        <div tabId="process" className="business-content">
          <section className="business-intro-section">
            <h2 className="business-intro-title"> 프로세스</h2>
            <p className="business-intro-description">
              상담부터 계약, 인수인계, 배송까지 단계별로 체계적으로 진행합니다.
            </p>
          </section>

          <BusinessTransportProcessSection />
        </div>
      </IntroductionTabs>
    </div>
  );
};

export default BusinessProcessPage;

